import { apiFetch, getApiUrl } from './client';

export const BRANDS = [
  'adidas', 'Alexander McQueen', 'AMI Paris', 'AMIRI', 'Balenciaga', 'Burberry', 'Carhartt WIP',
  'Celine', 'Chanel', 'Comme Des Garçons Play', 'Diesel', 'Dolce & Gabbana', 'FEAR OF GOD ESSENTIALS',
  'Fendi', 'Givenchy', 'Gucci', 'Hermès', 'Issey Miyake', 'Jacquemus', 'Kenzo', 'LOEWE',
  'Louis Vuitton', 'Maison Kitsuné', 'Maison Margiela', 'Miu Miu', 'Moncler', 'Moschino', 'Nike',
  'Off-White', 'Palm Angels', 'Polo Ralph Lauren', 'Prada', 'Saint Laurent', 'Stone Island', 'Stüssy',
  'Supreme', 'The North Face', 'Thom Browne', 'Valentino', 'Versace', 'Vivienne Westwood', '没有品牌',
] as const;

export const BRANDS_BATCH2 = [
  'adidas', 'Acne Studios', 'Aimé Leon Dore', 'Alexander McQueen', 'Alo Yoga', 'AMI Paris', 'AMIRI',
  "Arc'teryx", 'Balenciaga', 'Bottega Veneta', 'Burberry', 'Carhartt WIP', 'Cartier',
  'Casablanca', 'Celine', 'Chanel', 'Comme Des Garçons Play', 'Corteiz', 'Diesel', 'Dolce & Gabbana',
  'FEAR OF GOD ESSENTIALS', 'Fendi', 'Gallery Dept.', 'Ganni', 'Givenchy', 'Gucci', 'Hermès',
  'Issey Miyake', 'Jacquemus', 'Kenzo', 'Kith', 'Lemaire', 'LOEWE', 'Louis Vuitton', 'Maison Kitsuné',
  'Maison Margiela', 'Marni', 'Miu Miu', 'Moncler', 'Moschino', 'Nike', 'Off-White', 'Palm Angels',
  'Polo Ralph Lauren', 'Prada', 'Represent', 'Rick Owens', 'Saint Laurent', 'Sporty & Rich',
  'Stone Island', 'Stüssy', 'Supreme', 'The North Face', 'The Row', 'Thom Browne', 'Valentino',
  'Van Cleef & Arpels', 'Versace', 'Vivienne Westwood', 'Yohji Yamamoto', '没有品牌',
] as const;

export const BRANDS_BATCH3 = [
  "没有品牌",
  "A.P.C.",
  "AAPE",
  "Abercrombie & Fitch",
  "Acne Studios",
  "adidas",
  "Aimé Leon Dore",
  "Alexander Wang",
  "Alo Yoga",
  "AMBUSH",
  "AMI Paris",
  "Amiri",
  "Anti Social Social Club",
  "Aritzia",
  "Armani Exchange",
  "ASICS",
  "Balenciaga",
  "Bally",
  "BALMAIN",
  "BAO BAO ISSEY MIYAKE",
  "BAPE",
  "Barbour",
  "Berluti",
  "Birkenstock",
  "Bottega Veneta",
  "Brunello Cucinelli",
  "Burberry",
  "Bvlgari",
  "C.P. Company",
  "Calvin Klein",
  "Canada Goose",
  "Carhartt",
  "Cartier",
  "Celine",
  "Chanel",
  "Christian Louboutin",
  "Chrome Hearts",
  "Club Monaco",
  "Coach",
  "COMME des GARÇONS",
  "Converse",
  "Cult Gaia",
  "Delvaux",
  "Descente",
  "Diesel",
  "Dior",
  "Dolce & Gabbana",
  "Dr. Martens",
  "Drew House",
  "Dunhill",
  "emis",
  "Emporio Armani",
  "Etro",
  "EVISU",
  "Fear of God",
  "Fear of God ESSENTIALS",
  "Fendi",
  "Ferragamo",
  "Fred Perry",
  "Free People",
  "GANNI",
  "GAP",
  "Gentle Monster",
  "Giorgio Armani",
  "Giuseppe Zanotti",
  "Givenchy",
  "Golden Goose",
  "Goyard",
  "Gucci",
  "Helly Hansen",
  "Hermès",
  "Hogan",
  "HOKA",
  "HOMME PLISSÉ ISSEY MIYAKE",
  "HUF",
  "Human Made",
  "Isabel Marant",
  "Issey Miyake",
  "J.Crew",
  "Jacquemus",
  "Jil Sander",
  "Jimmy Choo",
  "Jordan",
  "JW PEI",
  "Kate Spade New York",
  "Kenzo",
  "Khaite",
  "Kith",
  "Lacoste",
  "Lemaire",
  "Levi’s",
  "Loewe",
  "Longchamp",
  "Loro Piana",
  "Louis Vuitton",
  "lululemon",
  "Madewell",
  "Maison Kitsuné",
  "Maison Margiela",
  "Manolo Blahnik",
  "Marc Jacobs",
  "Mardi Mercredi",
  "Marimekko",
  "Marni",
  "MCM",
  "McQueen",
  "Michael Kors",
  "Missoni",
  "Miu Miu",
  "Mizuno",
  "MM6 Maison Margiela",
  "Moncler",
  "Moschino",
  "New Balance",
  "Nike",
  "Noah",
  "Oakley",
  "OBEY",
  "Off-White",
  "On",
  "Onitsuka Tiger",
  "Palace",
  "Palm Angels",
  "Patagonia",
  "Paul Smith",
  "PLEATS PLEASE ISSEY MIYAKE",
  "Prada",
  "Puma",
  "Ralph Lauren",
  "Reebok",
  "Reformation",
  "Represent",
  "Rhude",
  "Rick Owens",
  "RIMOWA",
  "Roberto Cavalli",
  "Roger Vivier",
  "Sacai",
  "Saint Laurent",
  "Salomon",
  "Self-Portrait",
  "SKIMS",
  "Sporty & Rich",
  "Stüssy",
  "Supreme",
  "The North Face",
  "The Row",
  "Theory",
  "Thom Browne",
  "Thrasher",
  "Tiffany & Co.",
  "Timberland",
  "Tod's",
  "TOM FORD",
  "Tommy Hilfiger",
  "Tory Burch",
  "TOTEME",
  "UGG",
  "Umbro",
  "Under Armour",
  "Undercover",
  "Uniqlo",
  "Valentino",
  "Van Cleef & Arpels",
  "Vans",
  "Versace",
  "Vetements",
  "Vince",
  "Vivienne Westwood",
  "Vuori",
  "WE11DONE",
  "Yeezy",
  "Yohji Yamamoto",
  "Zegna",
] as const;

export const BRAND_CUES = ['logo', '领标', '字母', '老花', '格纹', '条纹', '徽章', '扣具', '锁头', '图案', '鞋底'] as const;

export interface BrandItem {
  id: number;
  sort_index: number;
  cue: string;
  reason: string;
  box: number[];
  updated_by: string;
}

export interface BrandProposal {
  model: string;
  label: string;
  brand: string;
  name: string;
  reason?: string;
  items: { cue: string; reason: string; box: number[] }[];
}

export interface BrandSample {
  id: number;
  sample_key: string;
  split: string;
  brand: string;
  source_label: string;
  qc_status: string;
  qc_by: string;
  picked_model: string;
  proposals: BrandProposal[];
  items: BrandItem[];
}

export type DatasetSplit = 'train' | 'test';

export interface BrandListPage {
  total: number;
  all_total: number;
  offset: number;
  open_offset: number;
  open_total: number;
  split?: string;
  train_total?: number;
  test_total?: number;
  sample: BrandSample | null;
}

export function listBrandSample(offset: number, atOpen = false, batch: 1 | 2 | 3 = 1, split: DatasetSplit | '' = '') {
  const open = atOpen ? '&at=open' : '';
  const splitQuery = split ? `&split=${split}` : '';
  return apiFetch<BrandListPage>(`/v1/brand-locate/samples?offset=${offset}&batch=${batch}${open}${splitQuery}`);
}

export function brandImageUrl(sampleId: number) {
  return getApiUrl(`/v1/brand-locate/samples/${sampleId}/image`);
}

export function updateBrandName(id: number, brand: string) {
  return apiFetch<{ ok: boolean; brand: string }>(`/v1/brand-locate/samples/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ brand }),
  });
}

export function markBrandSample(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/brand-locate/samples/${id}/qc`, { method: 'POST' });
}

export function deleteBrandSample(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/brand-locate/samples/${id}`, { method: 'DELETE' });
}

export function adoptBrandProposal(id: number, model: string) {
  return apiFetch<{ ok: boolean; brand: string; items: BrandItem[] }>(`/v1/brand-locate/samples/${id}/adopt`, {
    method: 'POST',
    body: JSON.stringify({ model }),
  });
}

export function replaceBrandItems(id: number, body: { brand: string; items: { cue: string; reason: string; box: number[] }[] }) {
  return apiFetch<{ ok: boolean; brand: string; items: BrandItem[] }>(`/v1/brand-locate/samples/${id}/replace`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function createBrandItem(sampleId: number, body: { cue: string; reason?: string; box: number[] }) {
  return apiFetch<BrandItem>(`/v1/brand-locate/samples/${sampleId}/items`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateBrandItem(id: number, body: { cue: string; reason: string; box: number[] }) {
  return apiFetch<BrandItem>(`/v1/brand-locate/items/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteBrandItem(id: number) {
  return apiFetch<{ ok: boolean }>(`/v1/brand-locate/items/${id}`, { method: 'DELETE' });
}
